<template>
  <v-progress-linear 
    :active="loader"
    :indeterminate="loader"
    height="4"
    class="absolute bottom"
    color="deep-purple accent-4"
  />
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'HelperLoading',
  data: () => ({
    showLoader: false
  }),
  computed: {
     ...mapState('app', ['loader']),
  },
}
</script>

<style lang="scss" scoped>
.v-progress-linear {
  position: absolute;
  top: 65px;
  left: 0px;
}
</style>
